import { Button, styled } from '@mui/material'
import React, { useState, useRef } from 'react'
import BasicModal from './BaseModal'
import { MovieCreationOutlined } from '@mui/icons-material'

import { any } from 'prop-types'

const OpenButton = ({ ...props }) => (
  <Button {...props} color="default">
    <MovieCreationOutlined sx={{ fill: 'orange', width: 76, height: 76 }} />
  </Button>
)
const VideoModal = ({ video }) => {
  const [status, setStatus] = useState(false)
  const videoRef = useRef(null)

  const StyledVideo = styled('video')(() => ({
    width: '100%',
    maxHeight: '70vh'
  }))

  return (
    <BasicModal
      title="Postagem por vídeo"
      status={status}
      Caller={OpenButton}
      closeEvent={event => {
        setStatus(event)
      }}
      sx={{ minWidth: '60vw', width: { xs: '100vw', md: '60vw' } }}
    >
      <>
        <StyledVideo autoPlay controls ref={videoRef}>
          <source src={video} />
        </StyledVideo>
        <Button
          sx={{ mt: '1rem' }}
          onClick={() => {
            setStatus(false)
          }}
          variant="outlined"
          color="error"
        >
          Fechar
        </Button>
      </>
    </BasicModal>
  )
}

VideoModal.propTypes = {
  video: any
}

export default VideoModal
